import React from 'react';
import classNames from 'classnames';

import styles from './Pagination.module.scss';
import DispexButton from '../DispexButton/DispexButton';

const ellipsis = <div className={styles.ellipsis}>...</div>;

const Pagination = ({
  maxPage,
  setPageNumber,
  currentPageNumber,
  firstIndexOnPage,
  lastIndexOnPage,
  totalAmount,
  rootClassName,
  buttonClassName
}) => {
  const showLastPage = maxPage > 5 && currentPageNumber < maxPage - 5;
  const showFirstPage = currentPageNumber > 3;
  const pages = new Array(5)
    .fill(null)
    .map((_el, index) => {
      return currentPageNumber + (index - 2);
    })
    .filter((el) => el > 0 && el <= maxPage);

  return (
    <div className={classNames(styles.row, rootClassName)}>
      {!!totalAmount && (
        <div className={styles.text}>
          С {firstIndexOnPage + 1} по {lastIndexOnPage} из {totalAmount}
        </div>
      )}
      <div className={styles.buttonsRow}>
        {showFirstPage && (
          <>
            <DispexButton
              className={classNames(styles.button, buttonClassName, styles.buttonBeforeEllipsis)}
              onClick={() => setPageNumber(0)}
              type="secondary"
              invert={0 !== +currentPageNumber}
            >
              1
            </DispexButton>
            {ellipsis}
          </>
        )}
        {pages.map((page, index, arr) => {
          return (
            <DispexButton
              key={page}
              className={classNames(styles.button, buttonClassName, {
                [styles.buttonBeforeEllipsis]: index === arr.length - 1,
              })}
              invert={page - 1 !== +currentPageNumber}
              type="secondary"
              onClick={() => setPageNumber(page - 1)}
            >
              {page}
            </DispexButton>
          );
        })}
        {showLastPage && (
          <>
            {ellipsis}
            <DispexButton
              className={classNames(styles.button, buttonClassName)}
              invert={+maxPage - 1 !== +currentPageNumber}
              onClick={() => setPageNumber(maxPage - 1)}
              type="secondary"
            >
              {maxPage}
            </DispexButton>
          </>
        )}
      </div>
    </div>
  );
};

export default Pagination;
